import request from '@/util/request';
import qs from 'qs';
// 社区服务人员
export const getList = (params, options) =>
request.get('/api/v4ward/community/service/user/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/community/service/user/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/community/service/user/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/community/service/user/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/community/service/user/update', params,options)
